export default __webpack_public_path__ + "static/media/Mobile-VimeVest.e13ed6cc.png";